class QuoteButton extends HTMLElement {
  constructor() {
    super();
    this.dataEl = this.querySelector('[type="application/json"]');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.updateQuote.bind(this));
  }

  updateQuote() {
    function setLocalStorageItem(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.error("Error setting local storage item:", error);
      }
    }

    function getLocalStorageItem(key) {
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      } catch (error) {
        console.error("Error getting local storage item:", error);
        return null;
      }
    }

    // Disable add quote button
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    const buttonLabel = this.button.querySelector('span');
    if(buttonLabel) {
      buttonLabel.innerHTML = "ADDED!"
    }

    if(this.dataEl) {
      // Get the product quantity at click time
      const quantityInput = document.querySelector('product-quantity .quantity__input');
      let quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      const productData = this.dataEl.textContent ? JSON.parse(this.dataEl.textContent) : null;

      if(productData) {
        // Sets the quantity to product data
        productData.quantity = quantity;

        // Get the current local storage quote data
        const quote = getLocalStorageItem('user_quote');

        if(quote) {
          const variantExists = quote.some(item => item.variant_id === productData.variant_id);
          if(!variantExists) {
            setLocalStorageItem('user_quote', [...quote, productData]);
          } else {
            const existentVariantIndex = quote.findIndex(item => item.variant_id === productData.variant_id);
            quote[existentVariantIndex].quantity = quote[existentVariantIndex].quantity + productData.quantity;
            setLocalStorageItem('user_quote', [...quote]);
          }
        } else {
          setLocalStorageItem('user_quote', [productData]);
        }
      }
    }

    // Update quote count in header
    if(typeof window.updateQuoteCount === 'function') {
      window.updateQuoteCount();
    }

    setTimeout(() => {
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }, 1500);

    setTimeout(() => {
      if(buttonLabel) {
        buttonLabel.innerHTML = "ADD TO QUOTE"
      }
    }, 2500);
  }
}

if(!customElements.get('quote-button')) {
  customElements.define('quote-button', QuoteButton)
}
